module.exports = __webpack_public_path__ + "assets/images/cry-5f52e9c508b650f7f881f9031fbcfb17.png";